<template>
  <div>
    <transition-group name="fade" v-if="siteLoaderStatus && showSite">
      <div id="all-sections" class="sections" key="2">
        <TopNav />
        <template v-for="liveComponent in liveComponents">
          <component :is="liveComponent" :key="liveComponent.name"></component>
        </template>
        <Footer />
        <!-- <TopNav />
        <Landing />
        <Flex />
        <Banner banner-divider="zunino" />
        <Traditional />
        <Flexible />
        <Seating />
        <SeatingBK />
        <Banner bannerDivider="fans" />
        <PremiumSeating />
        <Banner bannerDivider="meadows" />
        <CoreBenefits />
        <Banner bannerDivider="Yarbrough" />
        <GiftOption />
        <Bobblehead />
        <Banner bannerDivider="ball" />
        <PartyAreas />
        <Banner bannerDivider="crowd" />
        <SingleGameSuites />
        <Banner bannerDivider="bat" />
        <LouisianaLedge />
        <Schedule />
        <Faq />
        <Banner bannerDivider="diamond" />
        <Summary />
        <Footer /> -->
      </div>
    </transition-group>
    <transition name="fade" v-else>
      <SiteLoader @setLoaderFinished="setLoaderFinished" />
    </transition>
  </div>
</template>

<script>
import SiteLoader from "@/components/global/SiteLoader";
import { mapActions, mapState } from "vuex";
import { navData } from "@/data/navData";
import TopNav from "@/components/TopNav/TopNav";
import Landing from "@/components/sections/Landing/Landing";
import Flex from "@/components/sections/Flex/Flex";
import CoreBenefits from "@/components/sections/CoreBenefits/CoreBenefits";
import Banner from "@/components/sections/Banner/Banner";
import GiftOption from "@/components/sections/GiftOption/GiftOption";
import Bobblehead from "@/components/sections/GiftOption/Bobblehead";
import PartyAreas from "@/components/sections/Party Areas/PartyAreas";
import SingleGameSuites from "@/components/sections/SingleGameSuites/SingleGameSuites";
import LouisianaLedge from "@/components/sections/LouisianaLedge/LouisianaLedge";
import Schedule from "@/components/sections/Schedule/Schedule";
import Footer from "@/components/sections/Footer/Footer";
import Faq from "../sections/Faq/Faq.vue";
import Summary from "@/components/sections/Summary/Summary.vue";
import Traditional from "@/components/sections/SeasonMemberships/Traditional";
import Flexible from "@/components/sections/SeasonMemberships/Flexible";
import PremiumSeating from "@/components/sections/PremiumSeating/PremiumSeating";
export default {
  name: "Layout",
  components: {
    PremiumSeating,
    Flexible,
    Traditional,
    SiteLoader,
    TopNav,
    Landing,
    Flex,
    CoreBenefits,
    Banner,
    GiftOption,
    Bobblehead,
    PartyAreas,
    SingleGameSuites,
    LouisianaLedge,
    Schedule,
    Footer,
    Faq,
    Summary,
  },
  created() {
    this.$root.$on("bv::scrollspy::activate", this.onActivate);
  },
  mounted() {
    this.$el
      .querySelector("#all-sections")
      ?.addEventListener("scroll", this.scrollListener);
  },
  beforeDestroy() {
    this.$el
      .querySelector("#all-sections")
      .removeEventListener("scroll", this.scrollListener);
    this.$root.$off("bv::scrollspy::activate", this.onActivate);
  },
  computed: {
    ...mapState(["global"]),
  },
  data() {
    return {
      showSite: true,
      siteLoaderStatus: false,
      liveComponents: this.$store.state.epitch.getSections,
      section: "",
      navLinks: [
        "#Landing",
        "#Flex",
        "#Traditional",
        "#Flexible",
        "#PremiumSeating",
        "#CoreBenefits",
        "#GiftOption",
        "#PartyAreas",
        "#SingleGameSuites",
        "#LouisianaLedge",
        "#Schedule",
        "#Faq",
        "#Summary",
      ],
    };
  },
  methods: {
    setLoaderFinished(status) {
      this.siteLoaderStatus = status;
    },
    ...mapActions(["setIsMobile"]),
    scrollListener() {
      const scroller = this.$el.querySelector("#all-sections");
      if (!scroller.scrollTop) {
        this.section = "";
      }
    },
    onActivate(target) {
      this.section = target;
      let sectionId = this.navLinks.findIndex((link) => link === target);
      this.$store.dispatch("postTracking", sectionId + 1);
    },
  },
};
</script>

<style lang="scss" scoped>
/* Fade Transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s ease-in-out;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.map {
  width: 100%;
  object-fit: contain;
}
#all-sections {
  overflow-y: scroll;
}
</style>
